import salesRoutes from './module/sales';			// 销售
import purchaseRoutes from './module/purchase';  	// 采购
import stockRoutes from './module/stock';			// 库存
import qualityRoutes from './module/quality';		// 质检
import repairRoutes from './module/repair';			// 维修
import otherRoutes from './module/other';			// 其它

export default [{
	path: '/',
	component: () => import('@/pages/index'),
	children: [{
		path: '',
		name: 'home',
		meta: {
			loginFree: true
		},
		props: route => route.query,
		component: () => import('@/pages/home/index')
	}, {
		path: 'bind',
		meta: {
			loginFree: true
		},
		props: route => route.query,
		component: () => import('@/pages/bind')
	}, {
		path: 'success/:scene',
		meta: {
			title(route) {
				return {
					in: '入库',
					out: '退库',
					allot: '调拨'
				}[route.params.scene]
			}
		},
		props: route => route.params,
		component: () => import('@/pages/success')
	}]
}, {
	path: '/sales',
	component: () => import('@/pages/index'),
	children: [
		...salesRoutes
	]
}, {
	path: '/purchase',
	component: () => import('@/pages/index'),
	children: [
		...purchaseRoutes
	]
}, {
	path: '/stock',
	component: () => import('@/pages/index'),
	children: [
		...stockRoutes
	]
}, {
	path: '/quality',
	component: () => import('@/pages/index'),
	children: [
		...qualityRoutes
	]
}, {
	path: '/repair',
	component: () => import('@/pages/index'),
	children: [
		...repairRoutes
	]
}, {
	path: '/',
	component: () => import('@/pages/index'),
	children: [
		...otherRoutes
	]
}, {
	path: '*',
	redirect: '/'
}];